import { render } from "./CartSkeleton.vue?vue&type=template&id=6825332f"
const script = {}

import "./CartSkeleton.vue?vue&type=style&index=0&id=6825332f&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__